import React from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import MinusSign from '@images/minus-sign.png';
import PlusSign from '@images/plus-sign.png';
import { useTranslation } from 'gatsby-plugin-react-i18next';

interface ITamponCountProps {
  title: string;
  subtitle: string;
  count: number;
  Image: any;
  canIncrease: boolean;
  canDecrease: boolean;
  onIncrease: () => void;
  onDecrease: () => void;
}

const SubscribeOptionTamponCount: React.FC<ITamponCountProps> = ({
  title,
  subtitle,
  count,
  Image,
  canIncrease,
  canDecrease,
  onIncrease,
  onDecrease
}) => {
  const { t } = useTranslation();
  return (
    <Container>
      <CounterWrap className="image-title-wrap">
        <Image />
        <CounterTitle>
          <p>{title}</p>
          <p>{subtitle}</p>
        </CounterTitle>
      </CounterWrap>
      <div className="counter-wrap" style={{ display: 'flex' }}>
        <AdjustButton onClick={onDecrease} disabled={!canDecrease}>
          <img className="minus-sign" src={MinusSign} alt="green minus sign" />
        </AdjustButton>
        <CountText>
          <p>{count}</p>
        </CountText>
        <AdjustButton onClick={onIncrease} disabled={!canIncrease}>
          <img className="plus-sign" src={PlusSign} alt="green plus sign" />
        </AdjustButton>
      </div>
    </Container>
  );
};

export default SubscribeOptionTamponCount;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-style: solid;
  border-color: ${Colors.ecru};
  border-radius: 2px;
  padding: 35px;
  border-width: 1px;

  @media (max-width: 768px) {
    padding: 20px;
    justify-content: space-between;
  }

  > svg {
    height: 18px;
    margin-right: 25px;

    @media (max-width: 768px) {
      height: 12px;
      width: 44px;
    }
  }
`;

const CounterTitle = styled.div`
  margin-right: 100px;

  @media (max-width: 768px) {
    width: 120px;
    margin-right: 20px;
    flex-grow: 1;
  }

  p {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0;

    @media (max-width: 768px) {
      font-size: 16px;
      font-weight: 700;
      line-height: 19px;
    }
  }

  p + p {
    font-weight: 400;
  }
`;

interface AdjustButton {
  disabled: boolean;
}

const AdjustButton = styled.button`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Colors.paleGold};
  transition: all 0.15s;
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 2px;
  pointer-events: ${({ disabled }: AdjustButton) => (disabled ? 'none' : 'all')};
  opacity: ${({ disabled }: AdjustButton) => (disabled ? '0.3' : '1')};

  &:hover {
    background: ${Colors.gold};
  }

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
  }

  img {
    width: 18px;
    height: 18px;

    @media (max-width: 768px) {
      width: 14px;
      height: 14px;
    }
  }

  img.minus-sign {
    height: 3px;

    @media (max-width: 768px) {
      height: 2px;
    }
  }
`;

const CountText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 50px;

  @media (max-width: 768px) {
    width: 40px;
    height: 38px;
  }

  p {
    font-family: 'Domaine';
    font-size: 32px;
    font-weight: normal;
    line-height: 38px;
    letter-spacing: 0;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;

const CounterWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;

  & > svg {
    @media (max-width: 1024px) {
      min-width: 55px;
    }
  }
`;
